import {useTranslation} from 'react-i18next'
import {get} from 'lodash-es'

import {useRails} from '~/react/contexts/rails'
import {
  WalletIcon,
  HomeIcon,
  CoinCashInIcon,
  DocumentIcon,
  CustomerIcon,
} from '~/react/icons'
import {useProductEnabled} from './useProductEnabled'
import {usePermissions} from './usePermissions'

export const useSideNavLinks = () => {
  const {t} = useTranslation('paymentsOnDemand')
  const {organisation} = useRails()
  const {data, isLoading} = usePermissions()
  const {enabled} = useProductEnabled()

  const creditNotesFeatureEnabled = get(
    organisation,
    'currentSupplier.creditNotesFeatureEnabled',
    false,
  )

  const newCreditNotes = get(
    organisation,
    'currentSupplier.newCreditNotes',
    false,
  )

  const daysPastMostOverdueInvoiceDueDate = get(
    organisation,
    'currentSupplier.daysPastMostOverdueInvoiceDueDate',
    0,
  )

  let invoicesUrl = '/invoices'
  if (daysPastMostOverdueInvoiceDueDate >= 25) {
    invoicesUrl =
      '/invoices?days_past_due_date=25&cashin_status=true&payment_status=unpaid'
  }
  if (daysPastMostOverdueInvoiceDueDate >= 33) {
    invoicesUrl =
      '/invoices?days_past_due_date=33&cashin_status=true&payment_status=unpaid'
  }

  const {
    screenAccess: {
      cashinScreen: cashinUnlocked,
      customersScreen: customersUnlocked,
      dashboardScreen: dashboardUnlocked,
      invoicesScreen: invoicesUnlocked,
      paymentsScreen: paymentsUnlocked,
      settingsScreen: settingsUnlocked,
    } = {},
  } = data || {}

  const generalLinks = enabled
    ? [
        {
          disabled: !dashboardUnlocked,
          visible: true,
          label: t('paymentsOnDemand:sideNav.generalLinks.dashboardLabel'),
          icon: <HomeIcon />,
          href: '/dashboard',
        },
        {
          disabled: !cashinUnlocked,
          visible: true,
          label: t('paymentsOnDemand:sideNav.generalLinks.cashInLabel'),
          icon: <CoinCashInIcon />,
          href: '/cashin',
        },
        {
          disabled: !invoicesUnlocked,
          visible: true,
          label: t('paymentsOnDemand:sideNav.generalLinks.invoicesIndexLabel'),
          icon: <DocumentIcon />,
          tag: creditNotesFeatureEnabled && newCreditNotes ? 'New' : null,
          href: invoicesUrl,
        },
        {
          disabled: !paymentsUnlocked,
          visible: true,
          label: t(
            'paymentsOnDemand:sideNav.generalLinks.inboundPaymentsIndexLabel',
          ),
          icon: <WalletIcon />,
          href: '/payments',
        },
        {
          disabled: !customersUnlocked,
          visible: true,
          label: t('paymentsOnDemand:sideNav.generalLinks.customersIndexLabel'),
          icon: <CustomerIcon />,
          href: '/customers',
        },
      ]
    : []

  return {
    isLoading,
    generalLinks,
    settingsUnlocked,
  }
}
